module.exports = __webpack_public_path__ + "static/media/arrow-right.8bd44f03.svg";